var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.78 7.644c.82-.82 2.187-.82 3.062.054.055.109 1.477 1.586 1.531 1.64.82.875.765 2.241-.11 3.061C5.55 22.622 5.387 22.73 5.223 22.895c-.875.874-2.242.82-3.062-.055C.247 20.763.684 21.255.63 21.2c-.875-.874-.82-2.24.054-3.06zM5.547 2.117c2.018 0 3.655 1.637 3.655 3.656 0 2.02-1.637 3.657-3.655 3.657-2.02 0-3.657-1.637-3.657-3.657 0-2.019 1.637-3.656 3.657-3.656zM21.239.92c.655-.601 1.694-.601 2.295.055.657.655.601 1.694-.054 2.295l-6.014 5.686c-.219-.383-2.022-2.187-2.24-2.351.163-.11 5.74-5.522 6.013-5.685z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat);
export default __webpack_public_path__ + "static/media/bat.a40620ec.svg";
export { ForwardRef as ReactComponent };